import comp from "./ModulesSection";
export default comp;
